import { Provincia } from './provincia';
import { Model } from './model';

export class ZonaGeografica extends Model {
    static apiUrl: string = "zone_geografiche";

    nome: string;
    descrizione: string;
    province: Provincia[];

    deserialize(input: any): ZonaGeografica {
        let retV: ZonaGeografica = new ZonaGeografica();

        retV = super.deserialize(input) as ZonaGeografica;

        if (input?.province) {
            retV.province = input.province.map(m => new Provincia().deserialize(m));
        }


        return retV;
    }

}
